const DEFAULT_PAGE_SIZE = 10
const DEFAULT_PAGES = [
  {
    value: 2,
    name: '2'
  },
  {
    value: 10,
    name: '10'
  },
  {
    value: 20,
    name: '20'
  },
  {
    value: 50,
    name: '50'
  },
  {
    value: 100,
    name: '100'
  },
  {
    value: 200,
    name: '200'
  }
]

export {
  DEFAULT_PAGE_SIZE,
  DEFAULT_PAGES
}
